<ion-header>
  <ind-page-title [viewData]="pageTitleData" (onControlClick)="onPageTitleControlClick($event)"></ind-page-title>
</ion-header>

<ion-content>
  <div class="sdr-loading" *ngIf="isLoading">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <div class="sdr-form" *ngIf="!isLoading">

    <!-- Details header — status shown as a colour-coded pill on the right
         (mirrors the meeting detail pane). -->
    <ind-section-header [viewData]="detailsHeader"></ind-section-header>

    <!-- Customer -->
    <div class="sdr-section">
      <div class="sdr-section-body">
        <div class="sdr-section-label">{{ 'CUSTOMER' | translate }}</div>
        <div class="sdr-customer-row">
          <!-- Gated on a resolved NAME, not on contactId: an offline record has
               the id but no name, which rendered a nameless empty avatar. -->
          <div class="sdr-customer-chip" *ngIf="customerName">
            <span class="sdr-avatar">{{ contactInitials }}</span>
            <span class="sdr-customer-name">{{ customerName }}</span>
          </div>
          <span class="sdr-value" *ngIf="!customerName">{{ 'NO_DATA' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Delivery Address -->
    <div class="sdr-section">
      <div class="sdr-section-body">
        <div class="sdr-section-label">{{ 'DELIVERY_ADDRESS' | translate }}</div>
        <div class="sdr-value-row">
          <span class="sdr-value">{{ deliveryAddressText }}</span>
        </div>
      </div>
    </div>

    <!-- Email Address -->
    <div class="sdr-section">
      <div class="sdr-section-body">
        <div class="sdr-section-label">{{ 'EMAIL_ADDRESS' | translate }}</div>
        <div class="sdr-value-row">
          <span class="sdr-value">{{ sdr?.alternateEmail || sdr?.emailAddress || ('NO_EMAIL' | translate) }}</span>
        </div>
      </div>
    </div>

    <!-- Products -->
    <div class="sdr-section" *ngIf="sdr?.products?.length">
      <div class="sdr-section-label">
        {{ 'PRODUCTS' | translate }}
        <span class="sdr-section-count">({{ sdr.products.length }})</span>
      </div>
      <div class="sdr-grid">
        <div class="sdr-grid-header">
          <div class="sdr-gc sdr-gc-product">{{ 'PRODUCT' | translate }}</div>
          <div class="sdr-gc sdr-gc-qty">{{ 'QUANTITY' | translate }}</div>
        </div>
        <div class="sdr-grid-row" *ngFor="let product of sdr.products">
          <div class="sdr-gc sdr-gc-product">
            <span class="sdr-grid-product-name">{{ product.skuName }}</span>
          </div>
          <div class="sdr-gc sdr-gc-qty">
            <span class="sdr-detail-qty-value">{{ product.qty }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Notes & Attachments. Composer is hidden (readOnly = true), but the
         note list is still editable + deletable per ADR-9 — those are the
         only editing affordances on the detail view. -->
    <sdr-notes-section
      [sdrId]="sdr?.id"
      [existingNotes]="notes"
      [readOnly]="true"
      (noteSaved)="onNoteSaved($event)"
      (noteDeleted)="onNoteDeleted($event)">
    </sdr-notes-section>

  </div>
</ion-content>
